export default __webpack_public_path__ + "static/media/Snd_Try3.a0410e05.mp3";